import React, { useState, useEffect, useRef } from 'react';

const Vision = () => {
  const [scale, setScale] = useState(1);
  const [containerHeight, setContainerHeight] = useState('auto'); // ← main change
  const [isNarrowScreen, setIsNarrowScreen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;

      const narrow = w < 768;
      setIsNarrowScreen(narrow);

      let newScale = 1;
      if (w < 1440) {
        newScale = Math.max(w / 1440, 0.55);
      }
      setScale(newScale);

      // We don't need to calculate scaled height anymore in most cases
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const VisionImages = [
    { id: 1, img: "./images/vis5.webp", pos: "50% 50%" },
    { id: 2, img: "./images/vis12.webp", pos: "50% 50%" },
    { id: 3, img: "./images/vis9.webp", pos: "50% 50%" },
    { id: 4, img: "./images/vis4.webp", pos: "50% 50%" },
    { id: 5, img: "./images/vis10.webp", pos: "50% 50%" },
    { id: 6, img: "./images/vis3.webp", pos: "50% 50%" },
    { id: 7, img: "./images/vis6.webp", pos: "50% 50%" },
    { id: 8, img: "./images/vis16.webp", pos: "50% 50%" },
    { id: 9, img: "./images/vis17.webp", pos: "50% 50%" },
    { id: 10, img: "./images/vis18.webp", pos: "50% 50%" },
    { id: 11, img: "./images/vis1.webp", pos: "0% 10%" },
    { id: 12, img: "./images/vis14.webp", pos: "50% 50%" },
    { id: 13, img: "./images/vis8.webp", pos: "50% 50%" },
    { id: 14, img: "./images/vis2.webp", pos: "50% 50%" },
    { id: 15, img: "./images/vis13.webp", pos: "50% 50%" },
    { id: 16, img: "./images/vis15.webp", pos: "50% 20%" },
    { id: 17, img: "./images/vis11.webp", pos: "50% 50%" },
    { id: 18, img: "./images/vis19.webp", pos: "50% 50%" },
    { id: 19, img: "./images/vis20.webp", pos: "50% 50%" },
    { id: 20, img: "./images/vis21.webp", pos: "50% 50%" },
  ];

  const row1 = VisionImages.slice(0, 10);
  const row2 = VisionImages.slice(10, 20);

  const MarqueeRow = ({ images, reverse = false, depth = 1, isRow2 = false }) => {
    const containerWidth = isRow2 ? 302.7 : 322.7; // 322.7 - 20 = 302.7
    const imageWidth = isRow2 ? 286.65 : 306.65; // 306.65 - 20 = 286.65

    return (
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          marginBottom: "16px",
          zIndex: depth,
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            background: "linear-gradient(to right, #ededed 0%, transparent 10%, transparent 90%, #ededed 100%)",
            zIndex: 5,
          }}
        />

        <div
          className={reverse ? "marquee-reverse" : "marquee-normal"}
          // className={"marquee-normal"}
          style={{
            display: "flex",
            width: "max-content",
          }}
        >
          {(isNarrowScreen ? [...images, ...images] : [...images, ...images, ...images]).map(
            (item, i) => (
              <div
                key={`${item.id}-${i}`}
                style={{
                  width: `${containerWidth}px`,
                  height: "401.9px",
                  background: "rgba(0, 0, 0, 0.04)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "16px",
                  borderRadius: "16px",
                  flexShrink: 0,
                }}
              >
                <img
                  src={item.img}
                  alt=""
                  style={{
                    width: `${imageWidth}px`,
                    height: "385.8px",
                    objectFit: "cover",
                    objectPosition: item.pos,
                    borderRadius: "16px",
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#ededed",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: isNarrowScreen ? "210px 0 40px 0" : "210px 0 60px 0",
      }}
    >
      <h1
        style={{
          fontSize: 'clamp(32px, 7vw, 110px)',
          margin: '0 0 40px 0',
          color: '#1a1a1a',
          letterSpacing: '-0.03em',
          lineHeight: '1.1',
          fontFamily: "HenriettaSemiB",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        We help you share your
        <br />
        <span style={{ color: '#7A3A20' }}>v</span>
        <span style={{ color: '#ECAA1D' }}>i</span>
        <span style={{ color: '#007A9A' }}>s</span>
        <span style={{ color: '#EDBEAD' }}>i</span>
        <span style={{ color: '#BC522B' }}>o</span>
        <span style={{ color: '#BADDC9' }}>n</span> accurately
      </h1>
      <div
        style={{
          height: isNarrowScreen
            ? '465px'
            : `${850 * scale}px`,
          width: "100%",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          ref={wrapperRef}
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "top center",
            width: scale < 1 ? "1440px" : "100%",
            margin: "0 auto",
            padding: "20px 0",
            flexShrink: 0,
          }}
        >
          <MarqueeRow images={row1} depth={2} />
          <div style={{ marginLeft: "60px" }}>
            <MarqueeRow images={row2} reverse depth={1} isRow2={true} />
          </div>
        </div>
      </div>

      <style>
        {`
          .marquee-normal {
            animation: scroll-left 50s linear infinite;
          }

          .marquee-reverse {
            animation: scroll-right 42s linear infinite;
          }

          @keyframes scroll-left {
            from { transform: translateX(0); }
            to { transform: translateX(-33.33%); }
          }

          @keyframes scroll-right {
            from { transform: translateX(-33.33%); }
            to { transform: translateX(0); }
          }

          @media (max-width: 768px) {
            .marquee-normal {
              animation-duration: 28s;
            }

            .marquee-reverse {
              animation-duration: 20s;
            }

            @keyframes scroll-left {
              from { transform: translateX(0); }
              to { transform: translateX(-50%); }
            }

            @keyframes scroll-right {
              from { transform: translateX(-50%); }
              to { transform: translateX(0); }
            }
          }
        `}
      </style>
    </div>
  );
};

export default Vision;